
<div *ngIf="infoDataApi && !getEnv().includes('prod')" 
   class="envMessage"
   matTooltip="Current env is {{getEnv()}}"
   matTooltipPosition="right">
   {{getEnv()}}
</div>
